/* Mobile disclosure only: retain original content, app inputs and desktop order. */
(() => {
  const mobile = matchMedia('(max-width: 768px)');
  const main = document.getElementById('MainContent');
  if (!main) return;
  const folds = [];
  const productSections = {
    pp_features: 'Key features', pp_why_choose: 'Why choose this product',
    pp_detail_gallery: 'Product details', pp_artwork: 'Artwork and templates',
    pp_timeline: 'Production and delivery', pp_faq: 'Questions and answers',
    pp_reviews: 'Customer reviews', pp_seo_bottom: 'About this product'
  };
  const homeSections = ['pp_home_gallery', 'pp_capabilities', 'pp_who', 'pp_bundles', 'pp_trade', 'pp_home_seo', 'pp_why'];

  function fold(nodes, label) {
    const details = document.createElement('details');
    details.className = 'pp-mobile-disclosure';
    const summary = document.createElement('summary');
    summary.textContent = label;
    const content = document.createElement('div');
    content.className = 'pp-mobile-disclosure__content';
    details.append(summary, content);
    const originals = nodes.map(node => {
      const anchor = document.createComment('mobile disclosure position');
      node.before(anchor);
      return { node, anchor };
    });
    nodes[0].before(details);
    nodes.forEach(node => content.append(node));
    folds.push({ details, originals });
    return details;
  }

  function sections() {
    main.querySelectorAll(':scope > .shopify-section').forEach(section => {
      const key = section.id.split('__').pop();
      const node = [...section.children].find(el => el.matches('section'));
      if (!node || !node.getBoundingClientRect().height) return;
      let label = document.body.classList.contains('template-product') && productSections[key];
      if (document.body.classList.contains('template-index') && homeSections.includes(key)) {
        label = node.querySelector('h2')?.textContent.trim().replace(/\s+/g, ' ');
      }
      if (label) fold([node], label);
    });
  }

  function compactHelp() {
    if (!mobile.matches) return;
    main.querySelectorAll('.pp-cap-embroidery-option .cl-po--help').forEach(node => {
      if (node.closest('details') || !node.textContent.trim()) return;
      fold([node], 'Embroidery details').classList.add('pp-mobile-help');
    });
  }

  function reveal(target) {
    for (let parent = target?.parentElement; parent; parent = parent.parentElement) {
      if (parent.matches('details')) parent.open = true;
    }
  }
  function hashTarget(hash) {
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); }
    catch (_) { return null; }
  }
  function revealHash() {
    const target = hashTarget(location.hash);
    if (target) { reveal(target); target.scrollIntoView({ block: 'start' }); }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    const target = hashTarget(url.hash);
    reveal(target);
    if (target && link.matches('.pp-mobile-rating')) {
      event.preventDefault();
      if (location.hash !== url.hash) history.pushState(null, '', url.hash);
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    }
  }, true);
  document.addEventListener('invalid', event => reveal(event.target), true);
  addEventListener('hashchange', revealHash);

  function update() {
    document.body.classList.toggle('pp-mobile-simple', mobile.matches);
    if (mobile.matches) {
      sections();
      compactHelp();
      if (location.hash) requestAnimationFrame(revealHash);
    } else {
      folds.splice(0).reverse().forEach(({ details, originals }) => {
        originals.forEach(({ node, anchor }) => { anchor.replaceWith(node); });
        details.remove();
      });
    }
  }
  mobile.addEventListener('change', update);
  update();
  const product = main.querySelector('.pp-product-studio');
  if (product) {
    // The native options app mounts its help asynchronously. Retain its nodes.
    let helpFrame;
    new MutationObserver(() => {
      cancelAnimationFrame(helpFrame);
      helpFrame = requestAnimationFrame(compactHelp);
    }).observe(product, { childList: true, subtree: true });
  }
})();
